import React from 'react'
import { Box, Button } from '@mui/material'
import { Delete } from '@mui/icons-material'
import { AccordionWrapper } from '../utility/AccordianWrapper'
import { FileSelector } from '../FileSelector'
import { uploadPartnerFile, deletePartnerFile, UrlKey } from './Utility'
import { openTab } from '../Helpers'
import { useParams } from 'infrastructure/routing'
import {
  useAtom,
  useAtomValue,
  useSetAtom,
} from 'infrastructure/state/jotai.wrapper'
import { partnerIdAtom, sourceFilesAtom } from './atoms'
import { AwsContentItem } from 'shared/types/ingestion'
import { ConfirmCommitButton } from 'shared/ui'
import { copyToClipboard, doInBatches } from '../../utility'
import { PlainLink } from 'app/components/RouteLink'

export function Partner() {
  const { partnerKey } = useParams()
  useSetAtom(partnerIdAtom)(partnerKey ?? '')
  const [files, refreshFiles] = useAtom(sourceFilesAtom)

  async function uploadFile(files: File[]) {
    if (!partnerKey) {
      return
    }
    const uploadFile = (file: File) => uploadPartnerFile(partnerKey, file)
    await doInBatches(files, uploadFile).finally(refreshFiles)
  }

  function deleteFile(fileName: string) {
    if (!partnerKey) {
      return
    }
    deletePartnerFile(partnerKey, fileName, UrlKey.exportUpload, refreshFiles)
  }

  return (
    <Box>
      <p>Partner</p>
      <h3>{partnerKey}</h3>
      <Box>
        <Button
          component={PlainLink}
          to={`/ingestion/partner/${partnerKey}/ingested`}
        >
          Ingested
        </Button>
      </Box>
      <FileSelector disabled={false} filesSelected={uploadFile} />
      <AccordionWrapper title={`Files ${files.length}`}>
        <Box>
          {files.map((f, i) => {
            return <FileDisplay key={i} file={f} deleteFile={deleteFile} />
          })}
        </Box>
      </AccordionWrapper>
    </Box>
  )
}

function FileDisplay({
  file,
  deleteFile,
}: {
  file: AwsContentItem
  deleteFile: (file: string) => void
}) {
  const partnerKey = useAtomValue(partnerIdAtom)
  return (
    <Box padding={'5px'}>
      <Box paddingBottom={'2px'}>
        <Button
          onClick={() => {
            openTab(file.URL)
          }}
        >
          {file.key}
        </Button>
        <ConfirmCommitButton onClick={() => deleteFile(file.key)}>
          <Delete />
        </ConfirmCommitButton>
        <Button
          onClick={() =>
            copyToClipboard(
              `https://kiddom-ingestion.s3.amazonaws.com/partners/${partnerKey}/export/${file.key}`,
            )
          }
        >
          Copy
        </Button>
      </Box>
      <Box color={'gray'} fontSize={'80%'}>
        <b>Added:</b> unknown
      </Box>
    </Box>
  )
}
